import React from "react";
import { nav } from "../data";
import styles from "../styles/components/NavBar.module.css";
import { Link } from "react-router-dom";

const NavBar = () => {
    return (
        <header className={styles.navBar}>
            <div>
                <ul>
                    {nav.map((item, idx) => (
                        <li key={idx}>
                            <Link to={item.link}>{item.name}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        </header>
    );
};

export default NavBar;
